export default __webpack_public_path__ + "static/media/trolley.ad73773d.jpg";